export const MANAGEMENT_OVERVIEW_CHART_SUFFIXES = [
    'generation',
    'irradiance',
    'pr-basic',
    'pr-normalized',
    'gauge-basic',
    'gauge-normalized',
] as const;

export type ManagementOverviewChartSuffix = (typeof MANAGEMENT_OVERVIEW_CHART_SUFFIXES)[number];

export function buildManagementOverviewChartId(
    stationId: number,
    suffix: ManagementOverviewChartSuffix
): string {
    return `${stationId}:${suffix}`;
}

export function buildExpectedManagementOverviewChartIds(stationIds: number[]): string[] {
    return stationIds.flatMap((stationId) =>
        MANAGEMENT_OVERVIEW_CHART_SUFFIXES.map((suffix) =>
            buildManagementOverviewChartId(stationId, suffix)
        )
    );
}

export function countManagementOverviewChartsPerStation(): number {
    return MANAGEMENT_OVERVIEW_CHART_SUFFIXES.length;
}
